import { BarChart } from "@mantine/charts";
import { useReportingStore } from "../../../../../stores/ReportingStore";
import { Group, Paper, Text } from "@mantine/core";
import LoaderStats from "../../LoaderStats";
import { useLanguage } from "../../../../../stores/LanguageStore";

const SmsSummary = () => {
  const lang = useLanguage((s) => s.language);
  const statisticsDate = useReportingStore((s) => s.actualStatsDate);
  const dateRange = useReportingStore((s) => s.dateRange);

  return (
    <Paper pos={"relative"} w={"100%"} p={"xl"} pt={"md"}>
      <LoaderStats isDate />

      <Group mb={32} justify="center">
        <Text size="lg" fw={600}>
          {lang.reports.sending_volume}{" "}
          {!dateRange.end_date && !dateRange.start_date
            ? lang.reports.last_60_days
            : lang.reports.per_date}
        </Text>
      </Group>

      <BarChart
        h={300}
        w={"100%"}
        data={statisticsDate}
        dataKey="date"
        series={[
          {
            name: "sms_sent",
            label: lang.reports.sms_sent,
            color: "green.6",
          },
        ]}
        yAxisLabel="Volume"
        xAxisLabel="Date"
        tickLine="y"
        barProps={{
          isAnimationActive: true,
          animationDuration: 600,
          radius: [8, 8, 0, 0],
        }}
      />
    </Paper>
  );
};

export default SmsSummary;
